import Vue from 'vue'
import axios from 'axios'
import { googleKeys } from '../prototype.js'
import firebase from 'firebase/app'
import 'firebase/database'

const google = Vue.mixin({
  data: () => {
    return {
      isSignedIn: false,
      access_token: null,
      gis_email: null,
      tokenClient: null
    }
  },
  methods: {
    gisInit () {
      window.gapi.client.init({
        apiKey: googleKeys.apiKey,
        discoveryDocs: googleKeys.discoveryDocs
      })
      const uid = firebase.auth().currentUser.uid
      if (uid) {
        firebase.database().ref('token/' + uid).once('value').then((snapshot) => {
          if (snapshot.exists()) {
            var token = snapshot.val().access_token
            var expires = snapshot.val().expires_in
            var createdAt = snapshot.val().createdAt
            if ((createdAt + ((expires - 120) * 1000)) - parseInt(new Date().getTime()) > 0) {
              this.access_token = token
              window.gapi.client.setToken(token)
              this.gisSignIn()
            }
          } else {
            // console.log('No data available')
          }
        }).catch((error) => {
          if (error) {
            // console.error(error)
          }
        })
      }
    },
    gisSignIn () {
      this.tokenClient = window.google.accounts.oauth2.initTokenClient({
        client_id: googleKeys.clientId,
        scope: googleKeys.scope,
        callback: (tokenResponse) => {
          this.gisTokenWrite(tokenResponse)
          this.access_token = tokenResponse.access_token
          this.gisInfo()
          this.isSignedIn = true
        }
      })
      if (window.gapi.client.getToken() === null) {
        // Prompt the user to select a Google Account and ask for consent to share their data
        // when establishing a new session.
        this.tokenClient.requestAccessToken({ prompt: 'consent' })
        // this.tokenClient.requestAccessToken({ prompt: '' })
      } else {
        // Skip display of account chooser and consent dialog for an existing session.
        this.tokenClient.requestAccessToken({ prompt: '' })
      }
    },
    gisInfo () {
      var vm = this
      axios.get('https://www.googleapis.com/oauth2/v1/userinfo', {
        headers: { Authorization: `Bearer ${this.access_token}` }
      }).then(function (response) {
        vm.gis_email = response.data.email
      }).catch(function (error) {
        if (error) {
        // console.log(error)
        }
      })
    },
    gisSignOut () {
      if (typeof window.gapi.client !== 'undefined') {
        const token = window.gapi.client.getToken()
        if (token !== null) {
          window.google.accounts.oauth2.revoke(this.access_token)
          window.gapi.client.setToken('')
        }
        const uid = firebase.auth().currentUser.uid
        if (uid) {
          firebase.database().ref('token/' + uid).remove()
        }
        this.isSignedIn = false
      }
    },
    gisTokenWrite (token) {
      const uid = firebase.auth().currentUser.uid
      firebase.database().ref('token/' + uid).set({
        'access_token': token.access_token,
        'expires_in': token.expires_in,
        'createdAt': parseInt(new Date().getTime())
      })
    }
  }
})

export default google
